import * as actionUtil from './js/Actions/index.js';
import { shuffle } from './js/utils.js';
import { resetToInitialPosition } from './js/helpers-board.js'

const board = document.querySelector('.board');
// const gameScore = document.querySelector('.scoreboard__score .scoreboard__value');
const GAMEOVER_DELAY = 550;
const MAX_CLICKS = 8;
const BUTTON_COUNT = 16;
const formatter = new Intl.NumberFormat();
let handleCloseCount = 0;
const gameOverReasons = {
  default: "You are out of clicks.",
  alice: "You chose the wrong button!",
}

const gameState = {
  gameOver: false,
  score: 0,
  maxClicks: MAX_CLICKS,
  clicks: 0,
  gameOverReason: "default",
  updateScore(points) {
    this.score += points;
    // document.querySelector('.scoreboard__score .scoreboard__value').innerText = formatScore();
    countUpToScore(this.score);

  },
  visitedModes: new Set(),
  updateMode(modeName) {
    let newModeNode = document.querySelector('.scoreboard__mode .scoreboard__value[aria-hidden="true"]');
    let oldModeNode = document.querySelector('.scoreboard__mode .scoreboard__value[aria-hidden="false"]');
    if (modeName !== 'Start') { this.visitedModes.add(modeName) };

    // oldModeNode.addEventListener("transitionend", () => {
    //   console.log("oldMode transition end");
    //   oldModeNode.classList.remove("slide-out--up");
    //   oldModeNode.classList.add("slide-in--up");
    //   oldModeNode.classList.add("opacity-0");
    //   oldModeNode.classList.add("absolute");
    //   oldModeNode.setAttribute("aria-hidden", true);
    // }, { once: true })

    oldModeNode.classList.remove("value--current");
    oldModeNode.classList.add("slide-out--up");

    newModeNode.innerText = modeName;
    newModeNode.classList.remove("opacity-0");
    newModeNode.classList.remove("absolute");
    newModeNode.setAttribute("aria-hidden", false);
    newModeNode.classList.remove("slide-in--up");
    newModeNode.classList.add("value--current");

    // Pulling out to avoid race condition between button click speed and set timeout
    oldModeNode.setAttribute("aria-hidden", true);
    setTimeout(() => {
      oldModeNode.classList.remove("slide-out--up");
      oldModeNode.classList.add("slide-in--up");
      oldModeNode.classList.add("opacity-0");
      oldModeNode.classList.add("absolute");
    }, window.innerWidth > 480 ? 80 : 0)

  },
  updateClicks(clickCount) {
    if (clickCount < 0) { clickCount = 0; }
    let newClickNode = document.querySelector('.scoreboard__clicks .scoreboard__value.opacity-0');
    let oldClickNode = document.querySelector('.scoreboard__clicks .scoreboard__value.value--current');

    oldClickNode.classList.remove("value--current");
    oldClickNode.classList.add("slide-out--left");

    newClickNode.innerText = clickCount;
    setTimeout(() => {
      newClickNode.classList.remove("opacity-0");
    }, window.innerWidth > 480 ? 80 : 0)

    newClickNode.classList.remove("absolute");
    newClickNode.setAttribute("aria-hidden", false);
    newClickNode.classList.remove("slide-in--left");
    newClickNode.classList.add("value--current");

    setTimeout(() => {
      oldClickNode.classList.remove("slide-out--left");
      oldClickNode.classList.add("slide-in--left");
      oldClickNode.classList.add("opacity-0");
      oldClickNode.classList.add("absolute");
      oldClickNode.setAttribute("aria-hidden", true);
    }, window.innerWidth > 480 ? 80 : 0);
  }
};

/*
 * Creates a transition effect of counting up to a particular score
 * @param targetScore - an int for the target score that should be counted up to
 *
 * @return none
 * */
function countUpToScore(targetScore) {
  const gameboardScoreNode = document.querySelector('.scoreboard__score .scoreboard__value');
  let gameboardScore = parseInt(gameboardScoreNode.innerText);
  const INCREASE_FACTOR = 0.2;
  if (targetScore === gameboardScore) return;
  let intervalId = setInterval(() => {
    if (targetScore === gameboardScore) {
      clearInterval(intervalId);
    }
    let diff = targetScore - gameboardScore;
    let step = 0;

    if (diff < 0) {
      step = Math.floor(diff * INCREASE_FACTOR);
      step = Math.min(step, -1);
      // Expecting -20, but will get -21
      if (gameboardScore + step < targetScore) {
        // Don't undershoot the score
        step = targetScore - gameboardScore;
      }
    }
    else {
      step = Math.ceil(diff * INCREASE_FACTOR);
      step = Math.max(step, 1);
      // Don't overshoot the score
      if (gameboardScore + step > targetScore) {
        step = targetScore - gameboardScore;
      }
    }
    gameboardScore += step;
    gameboardScoreNode.innerText = formatScore(gameboardScore);
  }, 30)
  // let currentScore = gameState.score;

  // while (gameboardScore !== targetScore) {
  //   gameboardScore += Math.ceil((targetScore - gameboardScore) * INCREASE_FACTOR);
  //   gameboardScoreNode.innerText = gameboardScore;
  // }
}

const uiState = {
  flashlightActivated: false,
  cursorsActivated: false,
};

let buttons = document.querySelectorAll('.board button');
//
// store the intial positions of each button
let initialPositions = {};

function getInitialPositions() {
  buttons.forEach((button) => {
    const { left, top } = button.getBoundingClientRect()
    initialPositions[button.id] = { left, top };
  });
}

function formatScore(score) {
  return formatter.format(score).toString();
  // if (gameState.score >= 0) {
  //   return gameState.score.toString().padStart(5, '0');
  // }
  // else {
  //   return `-${(gameState.score * -1).toString().padStart(5, '0')}`;
  // }
}

// function updateScore(points) {
//   gameState.score += points;
//   gameScore.innerText = formatScore();
// }


// const actionNames = [
//   actionUtil.randomScoreUpdate,
//   actionUtil.rotateBoardNormal,
//   actionUtil.rotateBoardRandom,
//   actionUtil.stack,
//   actionUtil.stack,
//   actionUtil.animateButtons,
//   actionUtil.minify,
//   actionUtil.buttonShuffle,
//   actionUtil.changeFonts,
//   actionUtil.mirrorText,
//   actionUtil.invertedCursor,
//   actionUtil.flashlight,
//   actionUtil.addCursors,
//   actionUtil.randomDestruct,
//   actionUtil.boardOnCursor,
//   actionUtil.removeNumbers,
//   actionUtil.hugeify,
//   actionUtil.alice,
//   actionUtil.veryLight,
//   actionUtil.randomNumber,
//   actionUtil.likeTime,
//   actionUtil.scrollTime,
//   actionUtil.clickFortune,
//   actionUtil.rick,
// ]
//
const cleanups = [];

function registerCleanup(callback) {
  cleanups.push(callback);
}

function runCleanups() {
  if (cleanups.length > 0) {
    for (let i = cleanups.length - 1; i >= 0; i--) {
      cleanups[i]();
      cleanups.pop();
    }
  }
}


let actions = [
  // { handler: actionUtil.scatterButtons, name: "Scatter", points: 0 },
  { handler: actionUtil.randomScoreUpdate, name: "Points!", points: 0 },
  { handler: actionUtil.extraClick, name: "Extra click", points: 0, once: true },
  { handler: actionUtil.resetPositions, name: "Reset", points: 0 },
  { handler: actionUtil.rotateBoardRandom, name: "Rotate", points: -53 },
  { handler: actionUtil.stack, name: "Stack", points: 181 },
  { handler: actionUtil.animateButtons, name: "Disco", points: 1759 },
  { handler: actionUtil.minify, name: "Minify", points: 59 },
  { handler: actionUtil.hugeify, name: "Hugeify", points: -47 },
  { handler: actionUtil.buttonShuffle, name: "Shuffle", points: 269 },
  { handler: actionUtil.changeFonts, name: "Ding Ding!", points: -157, deskOnly: true },
  { handler: actionUtil.mirrorText, name: "Mirrors", points: -59 },
  { handler: actionUtil.invertedCursor, name: "Funhouse", points: 277, deskOnly: true },
  { handler: actionUtil.flashlight, name: "Dark", points: 1553 },
  { handler: actionUtil.addCursors, name: "Cursors", points: -1019, deskOnly: true },
  { handler: actionUtil.randomDestruct, name: "Bye", points: -2069 },
  { handler: actionUtil.boardOnCursor, name: "Party", points: 449, deskOnly: true },
  { handler: actionUtil.removeNumbers, name: "Buttons", points: 150 },
  { handler: actionUtil.alice, name: "Rabbithole", points: 599 },
  { handler: actionUtil.veryLight, name: "Very light", points: -347 },
  { handler: actionUtil.randomNumber, name: "Numbers", points: -151 },
  { handler: actionUtil.likeTime, name: "Like", points: 0 },
  { handler: actionUtil.scrollTime, name: "Scroll", points: 0 },
  { handler: actionUtil.clickFortune, name: "Click your fortune", points: 0 },
  { handler: actionUtil.rick, name: "Rick", points: -2111 },
]


if (isMobileDevice()) {
  actions = actions.filter((action) => { return !action.deskOnly })
}

let actionIndecies = Array.from(Array(actions.length), (_, i) => i);
// shuffle(actions);
// Update score and call the handler for each button
// buttons.forEach((button, i) => {
//   // Main game loop
//   button.dataset.actionId = actionIndecies[i];
//   button.addEventListener('click', buttonClickHandler)
//   // button.addEventListener('click', async (event) => {
//   //   runCleanups();
//   //   console.log(actions[i].name);
//   //   gameState.updateScore(actions[i].points);
//   //   gameState.updateMode(actions[i].name);
//   //   gameState.clicks++;
//   //   console.log(gameState);
//   //   console.log(gameState.clicks);
//   //
//   //   await actions[i].handler.call(this, { gameState, uiState, board, buttons, event, handleGameOver, initialPositions, registerCleanup });
//   //
//   //   gameState.updateClicks(gameState.maxClicks - gameState.clicks);
//   //   console.log(gameState);
//   //
//   //   if ((gameState.clicks >= gameState.maxClicks) || gameState.gameOver) {
//   //     handleGameOver();
//   //   }
//   // })
// });
//
function setUpButtons() {
  if (isMobileDevice()) {
    actions = actions.filter((action) => { return !action.deskOnly })
  }
  // shuffle(actions);
  shuffle(actionIndecies);

  buttons.forEach((button, i) => {
    // Main game loop
    button.dataset.actionId = actionIndecies[i];
    button.addEventListener('click', buttonClickHandler);
    // button.addEventListener('click', async (event) => {
    //   runCleanups();
    //   console.log(actions[i].name);
    //   gameState.updateScore(actions[i].points);
    //   gameState.updateMode(actions[i].name);
    //   gameState.clicks++;
    //   console.log(gameState);
    //   console.log(gameState.clicks);
    //
    //   await actions[i].handler.call(this, { gameState, uiState, board, buttons, event, handleGameOver, initialPositions, registerCleanup });
    //
    //   gameState.updateClicks(gameState.maxClicks - gameState.clicks);
    //   console.log(gameState);
    //
    //   if ((gameState.clicks >= gameState.maxClicks) || gameState.gameOver) {
    //     handleGameOver();
    //   }
    // })
  });
}

/*
 * General wrapper function for handling button clicks. Calls the correct action handler and
 * updates the game state
 *
 * @return none
 * */
function buttonClickHandler(event) {
  // Guard against overclicking
  const actionId = event.target.dataset.actionId;
  runCleanups();
  gameState.updateScore(actions[actionId].points);
  gameState.updateMode(actions[actionId].name);
  gameState.clicks++;
  if (gameState.clicks > gameState.maxClicks) return;

  const maybePromise = actions[actionId].handler.call(this, { gameState, uiState, board, buttons, event, handleGameOver, initialPositions, registerCleanup })

  Promise.resolve(maybePromise)
    .then(() => {
      gameState.updateClicks(gameState.maxClicks - gameState.clicks);

      document.querySelector(".scoreboard__live-message").textContent = `Score: ${gameState.score}, Mode: ${actions[actionId].name}, Clicks left: ${gameState.maxClicks - gameState.clicks}`;
      if ((gameState.clicks === gameState.maxClicks) || gameState.gameOver) {
        handleGameOver();
      }
    });
}


/*
 * Helper function for handling the Game Over game state
 *
 * @return none
 * */
function handleGameOver() {
  gameState.gameOver = true;
  // gameState.updateMode("Game Over");
  setTimeout(() => showGameoverOverlay(), GAMEOVER_DELAY);
}

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
}
// if (isMobileDevice()) {
//   const ball = document.getElementById("ball");
//   ball.style.backgroundColor = "red";
// }
// else {
//   ball.style.backgroundColor = "blue";
// }

// // Testing mobile device orientation
// function handleOrientation(event) {
//   let beta = event.beta; //[-180, 180)
//   let gamma = event.gamma; // [-90, 90)
//   // console.log(t);
//   // console.log(a);
//   // console.log("beta");
//   // console.log(beta);
//
//   gamma += 90;
//   // beta += 0;
//   if (beta < 0) { beta = 0 };
//   if (beta > 90) { beta = 90 };

// const maxX = window.innerWidth - ball.clientWidth;
// const maxY = window.innerHeight - ball.clientHeight;
// ball.style.left = `${gamma / 180 * maxX}px`; // rotating device around the y axis moves the ball horizontally
// ball.style.top = `${beta / 90 * maxY}px`; // rotating device around the x axis moves the ball

// t.innerText = absolute;
// a.innerText = alpha;
// b.innerText = beta;
// g.innerText = gamma;
// }

// window.addEventListener("deviceorientation", handleOrientation);


/*
 * Displays the Game Over overlay and populates its fields
 * including the score, modelist, and leaderboard.
 * Adds buttons for restarting the game
 *
 * @return none
 * */
async function showGameoverOverlay() {
  const overlay = document.querySelector(".gameover-overlay");
  const closeBtn = document.querySelector(".gameover__close-btn");
  const scoreSpan = document.querySelector(".gameover__score");
  const board = document.querySelector(".board");
  const modeList = document.querySelector(".gameover__modelist");
  scoreSpan.innerText = formatScore(gameState.score);

  // if (gameState.gameOverReason !== "default") {
  document.querySelector(".gameover__reason").innerText = gameOverReasons[gameState.gameOverReason];
  // }

  document.querySelector(".gameover__modelist__count").innerText = gameState.visitedModes.size;
  document.querySelector(".gameover__modelist__total").innerText = actions.length;
  gameState.visitedModes.forEach((mode) => {
    const modeItem = document.createElement("li");
    modeItem.innerText = mode;
    modeItem.classList.add("gameover__modename");
    modeList.appendChild(modeItem);
  })

  if (gameState.visitedModes.size > 5) {
    modeList.classList.add("two-column");
  }

  overlay.hidden = false;
  overlay.setAttribute("aria-hidden", "false");
  // overlay.classList.remove("hidden");
  closeBtn.addEventListener("click", handleClose, { once: true });
  closeBtn.focus();
  board.setAttribute("inert", "true");

  runCleanups();

  await showLeaderboard();

  function handleClose() {
    handleCloseCount++;
    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    board.removeAttribute("inert");
    // overlay.classList.add("hidden");
    resetGame();
  }
}


/*
 * Resets the game board and game state to prepare it for a new round
 *
 * @return none
 * */
function resetGame() {
  gameState.gameOver = false;
  gameState.clicks = 0;
  gameState.updateClicks(MAX_CLICKS);
  gameState.maxClicks = MAX_CLICKS;
  gameState.score = 0;
  gameState.visitedModes.clear();
  gameState.gameOverReason = "default";
  document.querySelector('.scoreboard__score .scoreboard__value').innerText = formatScore(0);
  gameState.updateMode("Start");

  // const modes = document.querySelectorAll(".gameover__modename");
  // if (modes.length > 0) {
  //   modes.forEach((mode) => { mode.remove() });
  // }
  runCleanups();

  //Clear the array without reasssiging it
  cleanups.length = 0;

  uiState.cursorsActivated = false;
  uiState.flashlightActivated = false;

  setTheme();

  board.classList = 'board composite-transform';
  board.style = '';

  buttons = document.querySelectorAll('.board button');
  buttons.forEach((button) => button.removeEventListener("click", buttonClickHandler));

  for (let i = 0; i < BUTTON_COUNT - buttons.length; i++) {
    const newButton = document.createElement('button');
    newButton.id = `btn${buttons.length + i}`;
    newButton.type = 'button'
    board.appendChild(newButton);
  }

  // Reset the button node list
  buttons = document.querySelectorAll('.board button');

  buttons.forEach((button, i) => {
    button.classList = '';
    button.innerText = `Click it ${i + 1}`;
    button.id = `btn${i + 1}`;
    button.style = "";
  });

  document.querySelectorAll(".gameover__modelist li").forEach((el) => el.remove());

  resetToInitialPosition({ board, buttons, initialPositions });
  setUpButtons();
}

// On page load hide the gameoverlay to avoid a flash or layout shift, sets an color theme
addEventListener("load", () => {
  document.querySelector(".gameover-overlay").classList.remove("no-transition");
  document.body.classList.remove("hidden");
  setTheme();
  setUpButtons();
  getInitialPositions();
})

/*
 * Set a random color scheme for a round
 *
 * @return none
 * */
function setTheme() {
  let themes = ["default", "forest", "cornblue", "purplerain"];
  let existingTheme = "";
  for (let themeName of themes) {
    if (document.body.classList.contains(themeName)) {
      existingTheme = themeName;
      break;
    }
  }
  themes = themes.filter((theme) => theme !== existingTheme);
  if (existingTheme) {
    document.body.classList.remove(existingTheme);
  }
  document.body.classList.add(themes[Math.floor(Math.random() * themes.length)]);
}

/*
 * Sends scores to the api to be included in the leaderboard
 *
 * @return none
 * */
async function sendScore(name, score) {
  try {
    const res = await fetch('/api/submit/', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: name, score: score }),
    });
    const data = await res.json();
    if (!data.success) {
      console.error('Error submtting score:');
    }
  }
  catch (err) {
    console.error('Error submtting score:', err);
  }
}

/*
 * Fetch scores from the api
 *
 * @return JSON object containing the scores
 * */
async function getScores() {
  try {
    const res = await fetch('/api/top/');
    const scores = await res.json();
    return scores;
  }
  catch (err) {
    console.error('Error submtting score:', err);
    return;
  }
}

/*
 * Formats and add the leaderboard to the gameover score
 * @param scores - array of top scores
 * @param score – current score, used to highlight new high/low score
 *
 * @return none
 * */
function formatLeaderboard(scores, score) {
  const highScoreList = document.querySelector('.gameover__leaderboard__high');
  const lowScoreList = document.querySelector('.gameover__leaderboard__low');
  const highScores = scores.slice(0, scores.length / 2);
  const lowScores = scores.slice(scores.length / 2);
  const hiEl = highScores.map((item) => {
    if (item === score) {
      return `<li class="bold">${formatScore(item)}</li>`;
    }
    else {
      return `<li>${formatScore(item)}</li>\n`
    }
  })
  const loEl = lowScores.map((item) => {
    // return `<li> ${item.name}: ${item.score} </li>\n`
    if (item === score) {
      return `<li class="bold">${formatScore(item)}</li>`;
    }
    else {
      return `<li>${formatScore(item)}</li>\n`
    }
  })
  highScoreList.innerHTML = hiEl.join('');
  lowScoreList.innerHTML = loEl.join('');
};

// Determine if the score is in the top or low 5 scores
function isNewSuperScore(score, scoreList) {
  const MAX_ENTRIES = 10;
  scoreList.sort((a, b) => b - a);
  if (scoreList.length < MAX_ENTRIES) {
    return { highScore: true, lowScore: true };
  }
  // 10 / 2 = 5
  const PIVOT_INDEX = Math.floor((scoreList.length) / 2);
  if (score > scoreList[PIVOT_INDEX - 1]) {
    return { highScore: true, lowScore: false };
  };
  // Check if lower than highest low Score
  if (score < scoreList[PIVOT_INDEX]) {
    return { highScore: false, lowScore: true };
  };
  return { highScore: false, lowScore: false }
}

/* Handle all leaderboard processing:
 * -- fetch score
 * -- send super scores
 * -- format the leaderboard
 *
 * @return none
 */
async function showLeaderboard() {
  const scores = await getScores();
  if (scores !== null) {

    // Case for first score
    if (scores.length === 0) {
      console.log("First score!");
      await sendScore("temp-first", gameState.score);
      formatLeaderboard([gameState.score], gameState.score)
      return;
    }

    let scoreList = scores.map(s => s.score);

    // PIVOT INDEX is the first index where the low scores start
    // EXAMPLE
    // HIGH      | LOW
    // 0 1 2 3 4 | 5 6 7 8 9
    // LEN: 10 / 2 -> 5
    const PIVOT_INDEX = Math.floor((scoreList.length) / 2);

    const { highScore, lowScore } = isNewSuperScore(gameState.score, scoreList);
    if (highScore) {
      document.querySelector(".gameover__superScore").classList.remove("hidden");
      document.querySelector(".gameover__superScore__type").innerText = " High ";
      const highList = scoreList.slice(0, PIVOT_INDEX);
      highList.push(gameState.score);
      highList.sort((a, b) => b - a);
      highList.pop(); // get rid of the lowest high score
      scoreList = [...highList, ...scoreList.slice(PIVOT_INDEX)];
      await sendScore("temp-high", gameState.score);
    }
    else if (lowScore) {
      document.querySelector(".gameover__superScore").classList.remove("hidden");
      document.querySelector(".gameover__superScore__type").innerText = " Low ";
      const lowList = scoreList.slice(PIVOT_INDEX);
      lowList.push(gameState.score);
      lowList.sort((a, b) => b - a);
      lowList.shift(); // get rid of the highest low score
      scoreList = [...scoreList.slice(0, PIVOT_INDEX), ...lowList];
      await sendScore("temp-low", gameState.score);
    }
    formatLeaderboard(scoreList, gameState.score);
  }
}

// Gameloop
// while (!gameState.gameOver) {
//   if (gameState.clicks >= gameState.maxClicks) {
//     console.log("");
//   }
// }

// btn1.addEventListener('click', () => { actionUtil.randomScoreUpdate({ gameState }) });
// btn2.addEventListener('click', subtractRandPoints);
// btn3.addEventListener('click', () => { actionUtil.rotateBoardNormal({ board }) });
// btn4.addEventListener('click', () => { actionUtil.rotateBoardRandom({ board }) });
// btn5.addEventListener('click', (e) => { actionUtil.stack(e, { board, buttons }) });
// btn6.addEventListener('click', () => { actionUtil.animateButtons({ board, buttons }) });
// btn7.addEventListener('click', () => { actionUtil.minify({ board, buttons }) });
// btn8.addEventListener('click', () => { actionUtil.buttonShuffle({ board, buttons }) });
// btn9.addEventListener('click', () => { actionUtil.changeFonts({ buttons }) });
// btn10.addEventListener('click', () => { actionUtil.mirrorText({ buttons }) });
// btn11.addEventListener('click', () => { actionUtil.invertedCursor({ board, buttons }) });
// btn12.addEventListener('click', () => { actionUtil.flashlight({ flashlightActivated }) });
// btn13.addEventListener('click', () => { actionUtil.addCursors({ board, buttons, cursorsActivated }) });
// btn14.addEventListener('click', () => { actionUtil.randomDestruct({ buttons }) });
// btn15.addEventListener('click', () => { actionUtil.boardOnCursor({ board }) });
// btn16.addEventListener('click', () => { actionUtil.removeNumbers({ board, buttons }) });
// btn17.addEventListener('click', () => { actionUtil.hugeify({ board, buttons }) });
// btn18.addEventListener('click', () => { actionUtil.alice({ board, buttons }) });
// btn19.addEventListener('click', () => { actionUtil.veryLight({ board, buttons }) });
// btn20.addEventListener('click', () => { actionUtil.randomNumber({ board, buttons }) });
// btn21.addEventListener('click', () => { actionUtil.likeTime({ board, buttons }) });
// btn22.addEventListener('click', () => { actionUtil.scrollTime({ board, buttons }) });
// btn23.addEventListener('click', () => { actionUtil.clickFortune({ board, buttons }) });
// btn24.addEventListener('click', () => { actionUtil.rick({ board, buttons }) });
//
//
//
//
//
//
//
//Starting btn1 / 0
// top: -162.967
// left: 0
// translateX  309px
// translateY  333.0px
// //startLeft = -198.28833
// //startTop 212.6
